// ListData.tsx
import React from "react";
import { ExpandMore } from "@mui/icons-material";
import DaypartDashboardTable from "../../DaypartDashboardTable";

interface ListDataProps {
  openIndices: number[];
  handleToggle: (index: number) => void;
  handleTabFiltersChange: (key: string, value: any, idx: number) => void;
  menuPlans: any[];
  handleUMExport: (row: any) => void;
  handleClientExport: (row: any) => void;
}

const ListData: React.FC<ListDataProps> = ({ openIndices, handleToggle, menuPlans, handleTabFiltersChange, handleUMExport, handleClientExport }) => {
  return (
    <>
      {menuPlans.length ? menuPlans.map((daypart: any, idx: number) => (
        <div key={daypart.daypartcode || idx} className={`innrBox ${openIndices.includes(idx) ? "active" : ""}`}>
          <div className="flex align-items-center justify-content-between">
            <button onClick={() => handleToggle(idx)} className={`flex align-items-center dropDownButton wd-140 ${openIndices.includes(idx) ? "active" : ""}`}>
              <span><ExpandMore /></span> {daypart.name}
            </button>
          </div>
          {openIndices.includes(idx) && (
            <div className="content">
              <div className="nested-content">
                <DaypartDashboardTable
                  data={daypart.rows}
                  dropdownOptions={daypart.dropdownOptions}
                  filters={daypart.filters}
                  handleTabFilters={(key: string, value: any) => handleTabFiltersChange(key, value, idx)}
                  plandatesArray={daypart.plandatesArray}
                  handleUMExport={handleUMExport}
                  handleClientExport={handleClientExport}

                />
              </div>
            </div>
          )}
        </div>
      )) :
        <div className="noData">
          No data available
        </div>
      }
    </>
  );
};

export default ListData;
